module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade-btn"
    }
  }, [(_vm.isVisible) ? _c('button', {
    staticClass: "goback-btn bg-light",
    class: {
      active: _vm.isActive
    },
    on: {
      "click": _vm.nextView
    }
  }, [_c('div', {
    staticClass: "h6 medium sect"
  }, [_vm._v("\n\t\t\t<\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "h7 c-dark sect",
    class: {
      centertext: _vm.number === '00'
    }
  }, [(_vm.number !== '00') ? _c('span', {
    staticClass: "regular"
  }, [_vm._v(_vm._s(_vm.number))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "medium upcase"
  }, [_vm._v(_vm._s(_vm.title))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14b2ee7d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/GoBackBtn.vue
// module id = 622
// module chunks = 0